// TODO - remove lint disable when editing this file
/* eslint-disable */
import { ACTION_INIT } from './commonActions'
import { createAction } from 'redux-actions'
import { pick, get, negate } from 'lodash/fp'
import { path, pathOr, either } from 'ramda'
import { hasPermission } from '../modules/services/permission'

const ACTION_LEGACY_TAB_CHAGE = 'ellipsis.angular.change_tab'
const ACTION_TYPOGRAPHY_FEEDBACK = 'ellipsis.editor.typographyFeedback'
export const typographyFeedbackAction = createAction(ACTION_TYPOGRAPHY_FEEDBACK)

export const ACTION_LOCK_DETAILS = 'ellipsis.app.lock'
export const lockDetailsAction = createAction(ACTION_LOCK_DETAILS)

// React change tab event
export const ACTION_ACTIVE_TAB = 'ellipsis.app.activeTab'
export const setActiveTab = createAction(ACTION_ACTIVE_TAB)

// Set only active tab when canceling unsaved changes prompt
export const ACTION_SET_ONLY_ACTIVE_TAB = 'ellipsis.app.setOnlyActiveTab'
export const setOnlyActiveTab = createAction(ACTION_SET_ONLY_ACTIVE_TAB)

export const ACTION_STORY_LOADED = 'ellipsis.app.storyLoaded'
export const storyLoadedAction = createAction(ACTION_STORY_LOADED)

export const ACTION_STORY_SAVED = 'ellipsis.angular.save_success'

export const ACTION_SEND_TO_PRINT = 'ellipsis.app.sendToPrint'

export const ACTION_SEND_TO_PRINT_RESOLVED = 'ellipsis.app.sendToPrintResolved'
export const sendToPrintResolved = createAction(ACTION_SEND_TO_PRINT_RESOLVED)
export const getSendToPrintStatus = get(['appState', 'isSendToPrintLoading'])

export const ACTION_GO_TO_LIVE_STORY = 'ellipsis.app.goToLiveStory'

export const canNotEditOrCreateStory = negate(
  path(['appState', 'canEditOrCreateStory'])
)

export const canNotCirculateStory = negate(
  path(['appState', 'canCirculateStory'])
)

export const getLockDetails = get(['appState', 'lockDetails'])
export const storyLockedAccessor = negate(
  pathOr(false, ['appState', 'lockDetails', 'isMyLock'])
)
export const storyReadonlyAccessor = pathOr(false, [
  'appState',
  'lockDetails',
  'readonly',
])
export const storyLockedOrReadonlyAccessor = either(
  storyLockedAccessor,
  storyReadonlyAccessor
)

export const activeTab = get(['appState', 'activeTab'])
export const previousTab = get(['appState', 'previousTab'])
export const userRolesAuth = get(['appState', 'userRolesAuth'])

export const canCloneStory = get(['appState', 'canCloneStory'])
export const canDeleteStory = get(['appState', 'canDeleteStory'])

export const ACTION_SET_ONLINE = 'ellipsis.app.isOnline'
export const setIsOnline = createAction(ACTION_SET_ONLINE)
export const isOnline = get(['appState', 'isOnline'])

export const ACTION_SET_SIGNED_OUT = 'ellipsis.app.isSignedOut'
export const setIsSignedOut = createAction(ACTION_SET_SIGNED_OUT)
export const isSignedOut = get(['appState', 'isSignedOut'])

export const SET_STORY_OPERATION_IN_PROGRESS = 'SET_STORY_OPERATION_IN_PROGRESS'
export function getStoryOperationInProgress(state) {
  return state.appState.isStoryOperationInProgress
}
export function setStoryOperationInProgress(isInProgress) {
  return {
    type: SET_STORY_OPERATION_IN_PROGRESS,
    payload: isInProgress,
  }
}

// Binary flags for typography actions
export const TypographyFlags = {
  NONE: 0,
  BOLD: 1,
  ITALIC: 2,
  UNDERLINE: 4,
  ANCHOR: 8,
  STRIKETHROUGH: 16,
  COMMENT: 32,
}

export const EllipsisTabs = {
  Planning: 0,
  Compose: 1,
  Meta: 2,
  FeaturedImage: 3,
  FeaturedMedia: 4,
  Variants: 5,
  Circulate: 'circulate',
}

// Initial state for editor

const initialState = {
  userRolesAuth: {
    story: {
      cloneStory: {},
      createStory: {},
      deleteStory: {},
      editStory: {},
    },
  },
  lockDetails: {
    isMyLock: false,
    lockedBy: '',
    readonly: false,
  },
  typographyButtonsState: {
    hasBold: false,
    hasItalic: false,
    hasUnderline: false,
    hasAnchor: false,
    hasComment: false,
  },
  activeTab: EllipsisTabs.Compose,
  previousTab: EllipsisTabs.Compose,
  canCloneStory: false,
  canDeleteStory: false,
  canCirculateStory: false,
  canEditOrCreateStory: false,
  isOnline: true,
  isSignedOut: false,
  isSendToPrintLoading: false,
  orgName: '',
  // Create, save, delete, publish, & unpublish
  isStoryOperationInProgress: false,
}

// lodash functor to extract type and _id from Feature
const ellipsisFeaturePicker = pick(['type', '_id'])

// Angular-forwarded ELEMENT_FOCUS_CHANGE event
const ELEMENT_FOCUS_CHANGE = 'ellipsis.angular.element_focus_change'

// story locked due to inactivity timeout action
export const STORY_INACTIVITY_LOCK =
  'ellipsis.angular.lock_story_inactive_timeout'

// A reducer https://redux.js.org/docs/basics/Reducers.html#handling-actions for Ellipsis
// application state. Each action handler should return a copy of the state.
// It's not restricted, however, state should not be mutated.
export default function appReducer(state = initialState, action) {
  switch (action.type) {
    // Init action is dispatched during startup or app reset, such as logout
    case ACTION_INIT:
      const [orgNameFromUrl] =
        (window.location.hostname &&
          window.location.hostname.match(/[\w-]+?(?=\.arcpublishing\.com)/)) ||
        ''
      return Object.assign({}, state, initialState, {
        userRolesAuth: window.userRolesAuth,
        orgName: orgNameFromUrl === 'localhost' ? 'staging' : orgNameFromUrl,
      })

    case ACTION_TYPOGRAPHY_FEEDBACK:
      return {
        ...state,
        typographyButtonsState: {
          ...state.typographyButtonsState,
          flag: action.payload,
          hasBold: !!(action.payload & TypographyFlags.BOLD),
          hasItalic: !!(action.payload & TypographyFlags.ITALIC),
          hasUnderline: !!(action.payload & TypographyFlags.UNDERLINE),
          hasAnchor: !!(action.payload & TypographyFlags.ANCHOR),
          hasComment: !!(action.payload & TypographyFlags.COMMENT),
        },
      }

    // Set focusedFeature on Angular ELEMENT_FOCUS_CHANGE event
    case ELEMENT_FOCUS_CHANGE: {
      if (!action.payload) {
        return state
      }
      const { feature = {}, index } = action.payload
      return {
        ...state,
        focusedFeature: {
          feature: ellipsisFeaturePicker(feature || {}),
          index,
        },
      }
    }

    case ACTION_ACTIVE_TAB: {
      return {
        ...state,
        activeTab: action.payload,
        previousTab: state.activeTab,
      }
    }

    case ACTION_SET_ONLY_ACTIVE_TAB: {
      return {
        ...state,
        activeTab: action.payload,
      }
    }

    case ACTION_LOCK_DETAILS: {
      return {
        ...state,
        lockDetails: action.payload,
      }
    }

    case STORY_INACTIVITY_LOCK: {
      return {
        ...state,
        lockDetails: {
          ...state.lockDetails,
          readonly: true,
        },
      }
    }

    case ACTION_STORY_LOADED: {
      const hasStoryId = action.payload._id
      const newState = {
        ...state,
        canCloneStory:
          hasStoryId &&
          hasPermission(
            state.userRolesAuth.story.cloneStory,
            action.payload.canonical_website
          ),
        canDeleteStory: hasPermission(
          state.userRolesAuth.story.deleteStory,
          action.payload.canonical_website
        ),
        canEditOrCreateStory:
          (!hasStoryId &&
            hasPermission(state.userRolesAuth.story.createStory)) ||
          (hasStoryId &&
            hasPermission(
              state.userRolesAuth.story.editStory,
              action.payload.canonical_website
            )),
        canCirculateStory: hasPermission(state.userRolesAuth.story.circulate),
      }
      if (hasStoryId) {
        return newState
      } else {
        return {
          ...newState,
          activeTab: EllipsisTabs.Planning,
          previousTab: EllipsisTabs.Planning,
        }
      }
    }

    case ACTION_LEGACY_TAB_CHAGE: {
      return {
        ...state,
        selectedTab: action.payload.tab,
      }
    }

    case ACTION_SET_ONLINE: {
      return {
        ...state,
        isOnline: action.payload,
      }
    }

    case ACTION_SET_SIGNED_OUT: {
      return {
        ...state,
        isSignedOut: action.payload,
      }
    }

    case ACTION_SEND_TO_PRINT: {
      return {
        ...state,
        isSendToPrintLoading: true,
      }
    }

    case ACTION_SEND_TO_PRINT_RESOLVED: {
      return {
        ...state,
        isSendToPrintLoading: false,
      }
    }

    case SET_STORY_OPERATION_IN_PROGRESS: {
      return {
        ...state,
        isStoryOperationInProgress: action.payload,
      }
    }
    // Reducer receives all actions, not only for application state. It gives a flexibility to
    // update this piece of state even for non-edtior actions.
    // For non-handled actions the same state should be returned
    default:
      return state
  }
}
